import React from 'react';

import { defaultInitialsFieldHeightPx, defaultInitialsFieldWidthPx, Select } from '@aline/common';
import { useSelectCurrentUser } from 'src/gql';
import { useRefreshableFilestackImg } from 'src/helpers/integrations/filestack-download';
import type { ReactSetStateAction } from 'src/types';

interface TypedInitialsPreviewProps {
  setTypedInitialsPreviewCanvas: ReactSetStateAction<HTMLCanvasElement | null>;
  typedInitials: string;
}

export function TypedInitialsPreview({
  setTypedInitialsPreviewCanvas,
  typedInitials,
}: TypedInitialsPreviewProps): JSX.Element {
  const currentUser = useSelectCurrentUser();
  const { onError, src } = useRefreshableFilestackImg(currentUser?.settings.signatureInitialsImg);

  if (!typedInitials && src)
    return (
      <div
        style={{
          height: defaultInitialsFieldHeightPx,
          overflow: 'visible',
          position: 'relative',
          width: defaultInitialsFieldWidthPx,
        }}
      >
        <img
          alt="signature-initials"
          data-cy={Select.dialog.signatureDialog.typedInitialsImg}
          height={defaultInitialsFieldHeightPx}
          src={src}
          width={defaultInitialsFieldWidthPx}
          onError={onError}
        />
      </div>
    );

  return (
    <div
      style={{
        height: defaultInitialsFieldHeightPx,
        overflow: 'visible',
        position: 'relative',
        width: defaultInitialsFieldWidthPx,
      }}
    >
      <canvas
        ref={setTypedInitialsPreviewCanvas}
        data-cy={Select.dialog.signatureDialog.typedInitialsCanvas}
        height={defaultInitialsFieldHeightPx}
        width={defaultInitialsFieldWidthPx}
      />
    </div>
  );
}
